export enum ItemStylesByKeyPriorities {
  Selected = 1,
  Error = 2,
  Edited = 3,
}
